module.exports = __webpack_public_path__ + "static/media/error_circle.94178ad7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/error_circle.svg
// module id = 211
// module chunks = 21